import React from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';

type GigServicesErrorBoundaryProps = Readonly<{
    children: React.ReactNode;
}>;

export const GigServicesErrorBoundary = ({ children }: GigServicesErrorBoundaryProps) => (
    <ErrorBoundary onError={onRenderError}>{children}</ErrorBoundary>
);

const onRenderError = (originalError) => {
    const err = new Error(`Failed while rendering the GigServices component`);
    logger.error(err, {
        cause: originalError,
    });
};
